var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import ReactDOM from 'react-dom';
import { createPrefixCls } from '../_utils/string';
import Loading from '../loading';
import Toast from './toast';
const prefixCls = createPrefixCls('toast');
let $toast;
let $timer;
const clearTimer = () => {
    $timer && window.clearTimeout($timer);
};
const removeToast = () => {
    if ($toast) {
        ReactDOM.unmountComponentAtNode($toast);
        $toast.remove();
        $toast = null;
    }
    clearTimer();
};
const createTimer = (delay, callback) => {
    $timer = window.setTimeout(() => {
        removeToast();
        callback();
    }, delay);
};
const createToast = (props, callback) => {
    const { delay = 2000 } = props;
    $toast = document.createElement('div');
    ReactDOM.render(React.createElement(Toast, Object.assign({}, props)), $toast);
    const $root = document.body;
    $toast && $root.appendChild($toast);
    delay && createTimer(delay, callback);
};
const handleRouteChange = () => {
    removeToast();
};
window.addEventListener('hashchange', handleRouteChange);
window.addEventListener('popstate', handleRouteChange);
const convertProps = (props) => {
    if (typeof props === 'object') {
        return Object.assign({ text: '' }, props);
    }
    else {
        return {
            text: props
        };
    }
};
const toast = (props) => __awaiter(void 0, void 0, void 0, function* () {
    yield new Promise((resolve) => {
        const fixedProps = convertProps(props);
        if ($toast) {
            removeToast();
            resolve(undefined);
        }
        createToast(fixedProps, () => {
            resolve(undefined);
        });
    });
});
toast.success = (props) => __awaiter(void 0, void 0, void 0, function* () {
    yield toast(Object.assign(Object.assign({}, convertProps(props)), { icon: 'success-circle' }));
});
toast.error = (props) => __awaiter(void 0, void 0, void 0, function* () {
    yield toast(Object.assign(Object.assign({}, convertProps(props)), { icon: 'close-circle' }));
});
toast.showLoading = (props) => {
    toast(Object.assign({ text: '加载中...', delay: 0, mask: true, icon: React.createElement(Loading, { block: true, className: prefixCls('loading') }) }, (props ? convertProps(props) : {})));
};
toast.hideLoading = () => {
    removeToast();
};
toast.hideToast = () => {
    removeToast();
};
export default toast;
